<template>
	<div class="publicBox billBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>发票申请</li>
			</ul>
		</div>
		
		<InvoiceForm
			v-model="infoForm"
			:loading="loading"
			loading-text="开票中，请稍候..."
			tip-title="发票说明"
			tip-content="您好，请正确核对开票信息，提交后不可修改。"
			submit-button-text="发票申请"
			:balance="balance"
			:is-reissue="false"
			@submit="handleSubmit"
		/>
	</div>
</template>

<script>
import InvoiceForm from '../../../components/InvoiceForm.vue';

export default {
	name: 'BillReq',
	components: {
		InvoiceForm
	},
	data() {
		return {
			loading: false,
			infoForm: {
				invoiceType: "增值税电子专用发票"
			},
			balance: {}
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		getData() {
			this.$reqToken("get", "/api/center/invoice/getUserBalance", {}).then((res) => {
				this.balance = res.data
			})
		},
		handleSubmit(formData) {
			this.loading = true;
			this.$reqToken("post", "/api/center/invoice", formData, {timeout: 120000}).then((res) => {
				if(res.code && res.code == 200) {
					this.$message.success(res.msg);
					this.infoForm = {invoiceType: "增值税电子专用发票"};
					this.getData();
					this.$router.push('/admin/bill');
				} else {
					this.$message.error(res.msg);
				}
			}).catch((error) => {
				this.$message.error("提交失败，请重试");
				console.error("发票申请失败:", error);
			}).finally(() => {
				this.loading = false;
			})
		}
	}
}
</script>

<style scoped>
	@import url("../../../assets/css/admin/bill.css");
</style>